import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import type { FeatureImportanceItem } from '../../../types';

interface Props {
  data: FeatureImportanceItem[];
  title?: string;
  maxItems?: number;
}

const COLORS = [
  '#1976d2', '#2196f3', '#42a5f5', '#64b5f6', '#90caf9',
  '#0d47a1', '#1565c0', '#1e88e5', '#2979ff', '#448aff',
];

export default function FeatureImportance({
  data,
  title = 'Feature Importance',
  maxItems = 20,
}: Props) {
  const chartData = data.slice(0, maxItems).map((item) => ({
    ...item,
    importance: Math.round(item.importance * 10000) / 10000,
  }));

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title} (top {chartData.length})
      </Typography>
      <ResponsiveContainer width="100%" height={Math.max(280, chartData.length * 28)}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 5, right: 20, bottom: 5, left: 100 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis
            dataKey="feature"
            type="category"
            width={90}
            tick={{ fontSize: 11 }}
          />
          <Tooltip />
          <Bar dataKey="importance" radius={[0, 4, 4, 0]}>
            {chartData.map((_, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
